import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import StyleEditorPage from './pages/StyleEditorPage'
import BillingPage from './pages/BillingPage'
import AdminPage from './pages/AdminPage'
import ExtensionAuthPage from './pages/ExtensionAuthPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StyleEditorPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/extension/auth" element={<ExtensionAuthPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
